import React, { PureComponent, Fragment } from 'react'
import styles from './Form.scss'
import animated from './animate.css'
import { Element } from 'react-scroll'
import $ from 'jquery'

export default class Form extends PureComponent {
  state = {
    finish: false,
  }

  _handleSendOnClick = () => {
    const mailRegex = /^([a-zA-Z0-9_.\-+])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/
    const realName = this._realNameEl.value.trim()
    const name = this._nameEl.value.trim()
    const email = this._mailEl.value.trim()
    const url = this._socialPlatformEl.value.trim()
    const popdailyId = this._popdailyId.value.trim()
    const fanCount = this._fanCount.value.trim()

    if (realName === '') {
      alert('名字是必填唷!')
    } else if (name === '') {
      alert('創作筆名是必填唷!')
    } else if (mailRegex.test(email) === false) {
      alert('信箱地址格式不正確!')
    } else if (url === '') {
      alert('請附上經營的平台唷!')
    } else if (popdailyId === '') {
      alert('PopDaily ID 是必填唷!')
    } else if (!this._agreementEl.checked) {
      alert('請閱讀注意事項')
    } else {
      $.post(
        'https://docs.google.com/forms/u/0/d/e/1FAIpQLSeCvAXTG1CPopjVs9k7ynRfi2cKeak5lQjoDewUSLve95TQQg/formResponse',
        {
          'entry.1766591187': realName,
          'entry.1945755525': name,
          'entry.144293068': email,
          'entry.1629828773': url,
          'entry.1321601727': popdailyId,
          'entry.530041802': fanCount,
        },
      )
      alert('報名成功！')
      // eslint-disable-next-line no-undef
      fbq('track', 'CompleteRegistration')
      this.setState({ finish: true })
    }
  }

  render() {
    const { finish } = this.state

    return (
      <Fragment>
        <style jsx>{styles}</style>
        <style jsx>{animated}</style>
        <Element name="form" />
        <div className="form">
          <div className="wrap">
            <h2>馬上報名成為Poper！</h2>
            {finish && <p>波波黛莉感謝你 :D </p>}
            {!finish && (
              <Fragment>
                <p>
                  我們在找有創作經驗的創作者，歡迎你們加入成為
                  Poper，收到您的資料後我們將會進行篩選，相關結果會於 7-14
                  個工作天內回覆至下方您填寫的聯絡信箱與您聯繫喔！提醒您，PopDaily將主動聯繫入選之報名者，未入選者將不再個別通知。
                </p>
                <br />
                <em>*必填</em>
                <h3>
                  您的姓名是？<em>*</em>
                </h3>
                <input ref={(el) => (this._realNameEl = el)} placeholder="範例：波黛莉" />
                <h3>
                  您的創作筆名是？<em>*</em>
                </h3>
                <input ref={(el) => (this._nameEl = el)} placeholder="範例：波波黛莉" />
                <h3>
                  您的聯絡E-mail是？<em>*</em>
                </h3>
                <p>請填寫常用之電子信箱，我們才能找到您唷！</p>
                <input
                  ref={(el) => (this._mailEl = el)}
                  placeholder="範例：sugoi.internet@gmail.com"
                />
                <h3>
                  目前經營的社群媒體平台是？（請附上連結）<em>*</em>
                </h3>
                <p>不論是Facebook/Instagram/痞客邦等等，請給我們參考喔！</p>
                <input
                  ref={(el) => (this._socialPlatformEl = el)}
                  placeholder="範例：http://popdaily.com.tw/"
                />
                <h3>
                  您的 PopDaily ID 是？<em>*</em>
                </h3>
                <p>您可以從您的 PopDaily 個人頁面中看到。</p>
                <img
                  alt="個人頁 mid 位置"
                  src="/statics/images/creator/landingPage/whereIsMyMid.png"
                />
                <input ref={(el) => (this._popdailyId = el)} />
                <h3>您經營的社群平台粉絲人數為？</h3>
                <input ref={(el) => (this._fanCount = el)} />
                <h3>創作者報名注意事項</h3>
                <p>
                  參加者經PopDaily入選成為本活動之創作者，同意於PopDaily平台發布之著作授權予PopDaily使用於全球地區，並保證其著作無侵犯第三人之權利或任何違法事由，若有侵權或違法事由，應由創作者自負相關法律責任。
                </p>
                <label>
                  <input type="checkbox" ref={(el) => (this._agreementEl = el)} />
                  我同意
                </label>
                <div
                  className="botton"
                  onClick={this._handleSendOnClick}
                  data-category="user"
                  data-action="submit.form"
                  data-label="popcreators"
                >
                  提交
                </div>
              </Fragment>
            )}
          </div>
          <div className="share">
            <a href="mailto:creators@sugoigroup.tw">
              <img src="/statics/images/creator/landingPage/gmail.png" />
            </a>
            <a href="https://line.me/R/ti/p/%40nvz8256p" target="_blank" rel="noopener noreferrer">
              <img src="/statics/images/creator/landingPage/line.png" />
            </a>
          </div>
        </div>
      </Fragment>
    )
  }
}
